module.exports = __webpack_public_path__ + "img/snapchat.1c369585.svg";